import React, { useState, useEffect } from 'react';
import { create, getList, deleteOne } from '../../common/v4/BackendProvider';
import { ToastContainer, toast } from 'react-toastify';
import Panel from "../../common/layout/Panel";
import Button from "../../common/Button";
import TextField from "../../common/Textfield";
import './tokens.css';

const Tokens = () => {
    const [tokens, setTokens] = useState([]);
    const [showAddForm, setShowAddForm] = useState(false);
    const [newTokenName, setNewTokenName] = useState('');
    const [generatedToken, setGeneratedToken] = useState(null);

    useEffect(() => {
        loadTokens();
    }, []);

    const loadTokens = () => {
        getList('/admin/tokens').then(response => {
            setTokens(response.data.data);
        }).catch(error => {
            toast.error("Error loading tokens: " + error.message);
        });
    };

    const handleAddToken = () => {
        if (!newTokenName.trim()) {
            toast.error("Please enter a token name");
            return;
        }

        create('/admin/tokens', { data: { name: newTokenName } })
            .then(response => {
                setGeneratedToken(response.data?.token?.token);
                setNewTokenName('');
                setShowAddForm(false);
                loadTokens();
                toast.success("Token created successfully");
            })
            .catch(error => {
                toast.error("Error creating token: " + error.message);
            });
    };

    const handleDeleteToken = (tokenId) => {
        if (window.confirm("Are you sure you want to delete this token?")) {
            deleteOne('/admin/tokens', tokenId)
                .then(() => {
                    loadTokens();
                    toast.success("Token deleted successfully");
                })
                .catch(error => {
                    toast.error("Error deleting token: " + error.message);
                });
        }
    };
    return (
        <Panel title="API Tokens">
            <div className="tokens-container">
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    closeOnClick={true}
                    pauseOnHover={true}
                    draggable={true}
                />

                {generatedToken && (
                    <div className="generated-token">
                        <h4>Your new token has been generated:</h4>
                        <div className="token-display">
                            <code>{generatedToken}</code>
                            <Button
                                value="Copy"
                                onClick={() => {
                                    navigator.clipboard.writeText(generatedToken);
                                    toast.success("Token copied to clipboard");
                                }}
                            />
                        </div>
                        <p className="warning">Please copy this token now. You won't be able to see it again!</p>
                        <Button
                            value="Close"
                            onClick={() => setGeneratedToken(null)}
                        />
                    </div>
                )}

                <div className="tokens-header">
                    <Button
                        value="Add New Token"
                        onClick={() => setShowAddForm(true)}
                    />
                </div>

                {showAddForm && (
                    <div className="add-token-form">
                        <TextField
                            label="Token Name"
                            value={newTokenName}
                            onChange={(value) => setNewTokenName(value)}
                            placeholder="Enter token name"
                        />
                        <div className="form-buttons">
                            <Button
                                value="Save"
                                onClick={handleAddToken}
                            />
                            <Button
                                value="Cancel"
                                onClick={() => {
                                    setShowAddForm(false);
                                    setNewTokenName('');
                                }}
                            />
                        </div>
                    </div>
                )}

                <table className="tokens-table">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Token</th>
                            <th>Created At</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tokens.map(token => (
                            <tr key={token.ATRCLIENTAPIACCESSID}>
                                <td>{token.ATRUSERNAME}</td>
                                <td>********</td>
                                <td>{new Date(token.ATRCREATETIME).toLocaleString()}</td>
                                <td>
                                    <Button
                                        value="Delete"
                                        onClick={() => handleDeleteToken(token.ATRCLIENTAPIACCESSID)}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </Panel>
    );
};

export default Tokens; 